export default "__VITE_PUBLIC_ASSET__ea0de16d__"